export class OpenSalesOrderMessage {
    action?: string;
    salesOrderId?: string;
    salesOrderNumber?: string;
    dispatchId?: string;
    dispatchNumber?: string;

    constructor(
        data?: Partial<OpenSalesOrderMessage>,
    ) {
        if (data) {
            this.action = data.action;
            this.salesOrderId = data.salesOrderId;
            this.dispatchId = data.dispatchId;
            this.salesOrderNumber = data.salesOrderNumber;
            this.dispatchNumber = data.dispatchNumber;
        }        
    }
}